import { forwardRef, useEffect } from "react";
import { useRef } from "react";
import { Row } from "../../Flex/ui";
import { Typography, useTheme } from "@mui/material";

const withUnit = (Component: React.ComponentType<any>) => {
  return forwardRef(
    (
      {
        type,
        placeholder,
        amount,
        amountRef,
        onInputChange,
        unit,
        ...props
      }: {
        type: string;
        placeholder: string;
        amount: number;
        amountRef: React.RefObject<HTMLInputElement>;
        onInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
        unit: string;
      },
      ref,
    ) => {
      const theme = useTheme();
      const measureRef = useRef<HTMLSpanElement>(null);

      useEffect(() => {
        if (amountRef?.current && measureRef?.current) {
          measureRef.current.style.font = getComputedStyle(amountRef.current).font;
          measureRef.current.textContent = amountRef.current.value || "0"; // Default to "0" if empty
          amountRef.current.style.width = `${measureRef.current.offsetWidth + 10}px`;
        }
      }, [amount]);

      const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        onInputChange(event);
        if (amountRef?.current && measureRef?.current) {
          measureRef.current.textContent = amountRef.current.value || "0"; // Default to "0" if empty
          amountRef.current.style.width = `${measureRef.current.offsetWidth + 10}px`;
        }
      };

      return (
        <Component
          unit={unit}
          type={type}
          placeholder={placeholder}
          amount={amount}
          amountRef={amountRef}
          measureRef={measureRef}
          onInputChange={handleInputChange}
          ref={ref}
          {...props}
        />
      );
    },
  );
};

export default withUnit;
